import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { UiAvatarComponent } from '@bling-fe/shared/ui-components/ui-avatar';
import {
  ElapsedTimePipe,
  InternalLinksPipe,
  LinkyPipe
} from '@bling-fe/shared/pipes';

@Component({
  selector: 'bl-comment-item',
  imports: [
    CommonModule,
    IonicModule,
    SvgIconComponent,
    UiAvatarComponent,
    TranslateModule,
    LinkyPipe,
    InternalLinksPipe,
    ElapsedTimePipe
  ],
  templateUrl: './comment-item.component.html',
  styleUrl: './comment-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommentItemComponent {
  @Input({ required: true }) id!: number;
  @Input({ required: true }) author!: {
    // Avatar
    id: number;
    first_name: string;
    last_name: string;
    avatar_url?: string | null;
    is_online?: boolean;
    // Component
    full_name: string;
  };
  @Input({ required: true }) body!: string;
  @Input({ required: true }) createdAt!: string;
  @Input() isEditing = false;

  @Output() optionsClick = new EventEmitter<{
    id: number;
  }>();
}
